import * as Yup from "yup";

export const changePasswordSchema = Yup.object({
  old_password: Yup.string()
      .required('Hozirgi parol majburiy'),
  new_password: Yup.string()
      .required('Yangi parol majburiy')
      .min(8, 'Yangi parol kamida 8 ta belgidan iborat bo\'lishi kerak'),
  new_password_confirm: Yup.string()
      .oneOf([Yup.ref('new_password'), undefined], 'Yangi parol qaytadan mos kelishi kerak')
      .required('Yangi parol qaytadan majburiy')
})